import { CommonModule } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MaterialModule } from '@fantaz/shared/ui/material';
import { PromoteCodeModalComponent } from './promote-code-modal/promote-code-modal.component';
import { LetDirective } from '@ngrx/component';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MaterialModule,
    ReactiveFormsModule,
    LetDirective,
  ],
  declarations: [PromoteCodeModalComponent],
  exports: [PromoteCodeModalComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SharedUiPromoteCodeModalModule {}
